import React, {useEffect, Fragment} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from "react-intl";
import uuid from "uuid";

import {setDiscountSections, setWorkSheetsCount, setWorkSheetsActiveIndex} from "./discountsActions";
import {
  getCurrentWorkSheetSections,
  getParsedWizardLogic,
  getUpdatedDiscountSectionsWithWizardLogic
} from "./discountsFunctions";
import {getFabricatorSubscriptions} from "../NewScope/newScopeActions";
import DiscountsAsideDisplayOption from "./DiscountsAsideDisplayOption";
import {UI_POPUP_TYPES} from "../../reducers/R_Popups";
import {setUiPopupState} from "../../actions/A_Popups";


const DiscountsAside = (props) => {
  const {
    discountSections, discountsReceived, workSheetsActiveIndex, setWorkSheetsActiveIndex, setUiPopupState,
    getFabricatorSubscriptions, setDiscountSections, setWorkSheetsCount, workSheetsCount
  } = props;

  useEffect(() => {
    getFabricatorSubscriptions();
    return () => {
      setWorkSheetsActiveIndex(0);
    }
  }, []);

  // const onCheck = () => {
  //   if (!checkboxChecked) {
  //     setDiscountSections(discountSections.map((discountSection) => {
  //       discountSection.wizardLogic = "{allWizards: true}";
  //       return discountSection
  //     }));
  //   } else {
  //     setDiscountSections(discountSections.map((discountSection) => {
  //       discountSection.wizardLogic = "";
  //       return discountSection
  //     }));
  //   }
  // }

  const addWorkSheets = () => {
    setWorkSheetsCount(workSheetsCount + 1);
    setWorkSheetsActiveIndex(workSheetsCount);
  }

  const onAddNewDisplayOption = (closePopup, uiPopupContext) => {
    const parsedLogic = getParsedWizardLogic(uiPopupContext.currentSheetSections[0], workSheetsActiveIndex);
    const displayOptions = parsedLogic ? parsedLogic.displayOptions || [] : [];

    const wizardLogic = {
      ...parsedLogic,
      "displayOptions": [...displayOptions, {
        id: uuid.v4(),
        forVisualizer: uiPopupContext.forVisualizer,
        forWizardId: uiPopupContext.forWizardId,
        forWizardHashId: uiPopupContext.forWizardHashId,
        forWizardName: uiPopupContext.forWizardName,
        forWizardGroupTitle: uiPopupContext.forWizardGroupTitle,
        forWizardGroupId: uiPopupContext.forWizardGroupId,
        forWizardGroupName: uiPopupContext.forWizardGroupName,
      }]
    };
    const updatedSections = getUpdatedDiscountSectionsWithWizardLogic(
      discountSections,
      wizardLogic,
      workSheetsActiveIndex
    );
    setDiscountSections(updatedSections);
    closePopup()
  }

  const addNewWorkSheets = () => {
    const currentSheetSections = getCurrentWorkSheetSections(discountSections, workSheetsActiveIndex);
    setUiPopupState({
      headerTextId: "discounts.addDisplayOptions",
      className: "",
      style: {maxWidth: "480px", maxHeight: "320px"},
      opened: true,
      type: UI_POPUP_TYPES.discountsDisplayOptions,
      context: {
        saveButtonDisabled: true,
        currentSheetSections,
      },
      buttons: [{}, {
        isSaveButton: true,
        className: "ui-button5 ui-button5--wide text-uppercase ui-button5--green",
        textId: "messageBox.buttons.save",
        onClick: onAddNewDisplayOption,
      }],
    });
  }

  if (!discountsReceived) {
    return (
      <aside className="discounts-sidebar">
        <div style={{height: "200px"}}>
          <div className="ui-loader"/>
        </div>
      </aside>
    )
  }
  return (
    <aside className="discounts-sidebar">
      <ul className="fix-ul">
        {Array.from(Array(workSheetsCount).keys()).map((workSheetIndex) => {
          const isActive = workSheetIndex === workSheetsActiveIndex;

          const currentSheetSections = getCurrentWorkSheetSections(discountSections, workSheetIndex);
          const parsedLogic = getParsedWizardLogic(currentSheetSections[0], workSheetIndex);
          const displayOptions = parsedLogic ? parsedLogic.displayOptions || [] : [];

          return (
            <li key={workSheetIndex}
                onClick={() => isActive ? null : setWorkSheetsActiveIndex(workSheetIndex)}
                className={"relative padding-24 link discounts-sidebar__item " + (isActive ? "app-bg" : "bordered--transparent")}>
              <span className="ui-title--gray flex mb-025">Worksheet {workSheetIndex + 1}</span>
              {/*{isActive ? null : <button className="ui-icon-remove2 ui-icon-remove2--small ui-icon-remove2--hover-white"/>}*/}
              {/*<div className="flex flex--center flex--start height-20">*/}
              {/*  <span>*/}
              {/*    Available for: <span className="color-green bold">*/}
              {/*    {displayOptions.length*/}
              {/*      ? displayOptions.length > 1*/}
              {/*        ? displayOptions.length + " Display Options"*/}
              {/*        : displayOptions[0].forWizardGroupId + ". " + (displayOptions[0].forWizardGroupTitle || displayOptions[0].forWizardGroupName)*/}
              {/*      : ""}*/}
              {/*  </span>*/}
              {/*  </span>*/}
              {/*  {isActive ? <button className="margin-l8 ui-icon-edit ui-icon-edit--small relative"*/}
              {/*                      onClick={() => setDiscountsPopupOpened(true)}/> : null}*/}
              {/*</div>*/}
              <ul className="fix-ul">
                {displayOptions.length ? (
                  <Fragment>
                    {displayOptions.map(displayOption => {
                      return <DiscountsAsideDisplayOption workSheetIndex={workSheetIndex}
                                                          key={displayOption.id}
                                                          wizardLogic={parsedLogic}
                                                          displayOption={displayOption}/>
                    })}
                    {isActive ? (
                      <li className="flex pt-025 flex flex--center">
                        <button onClick={addNewWorkSheets}
                                className="bold link--green font--12 flex flex--center bg-none border-none box-shadow-none link">
                          <span className="ui-icon-plus ui-icon-plus--green ui-icon-plus--small margin-0"/>
                          <span className="relative -top-05px">Add Options</span>
                        </button>
                      </li>
                    ) : null}
                  </Fragment>
                ) : (
                  <li className="flex pt-025">
                    <span className="color-blue bold">All Wizards</span>
                    {isActive ? <button className="margin-l8 ui-icon-edit ui-icon-edit--small relative"
                                        onClick={addNewWorkSheets}/> : null}
                  </li>
                )}
              </ul>
            </li>
          )
        })}
        <li className={"padding-24 flex flex--center"}>
          <button className={"ui-button5 ui-button5--green-plus ui-button5--bold text-capitalize"}
                  disabled={!workSheetsCount}
                  onClick={addWorkSheets}>
            <FormattedMessage id="account.title.add"/>
          </button>
        </li>
      </ul>
    </aside>
  )
}

const mapStateToProps = (store) => {
  const {discountsReceived, discountSections, workSheetsActiveIndex, workSheetsCount} = store.discountsState;
  return {
    discountsReceived,
    discountSections,
    workSheetsActiveIndex,
    workSheetsCount,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setWorkSheetsActiveIndex,
  setUiPopupState,
  getFabricatorSubscriptions,
  setWorkSheetsCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountsAside);
